module.exports = __webpack_public_path__ + "static/img/Band_nato_edge_red.cc3f772.png";